import React from 'react'
import { inheritPrimaryColor } from '../colors'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import { useScrollReset } from '../scroll'
import { reverse } from 'ramda'
import getContentProps from '../get-content-props'
import { useRouteMatch, Route, Switch, useParams } from 'react-router-dom'

const preloadedResearchInterests = typeof window !== 'undefined' && window.__data__ && window.__data__.researchInterests

const ResearchWrapper = ({ data, ...props }) => {
  const match = useRouteMatch()

  return (
    <Switch>
      <Route path={`${match.path}/:researchInterest`}>
        <Research data={data} {...props} />
      </Route>
      <Route path={match.path}>
        <Research data={data} {...props} />
      </Route>
    </Switch>
  )
}

const Research = styled(({ data, ...props }) => {
  const { researchInterest = 'general' } = useParams()
  const researchInterests = data ? data.researchInterests : preloadedResearchInterests
  useScrollReset()
  const activeResearchInterest = researchInterests.find(({ slug }) => slug === researchInterest) || researchInterests[researchInterests.length - 1]
  return (
    <div {...props}>
      <HeaderWrapper>
        <Header>Our Research</Header>
      </HeaderWrapper>
      <ContentWrapper>
        <ContentBig>
          <Nav>
            {reverse(researchInterests).map(({
              title: { rendered: title },
              slug
            }) => <NavItem to={`/research/${slug}`} key={slug} active={slug === researchInterest} children={title} />
            )}
          </Nav>
          <Text {...getContentProps(activeResearchInterest.acf.description)} />
          <Padding></Padding>
        </ContentBig>
        <ContentSmall>
          {reverse(researchInterests).map(({
            acf: { description },
            title: { rendered: title },
            slug
          }) => <>
            <NavItemSmall to={`/research/${slug}`} key={slug} active children={title} />
            {researchInterest === slug && <Text css='padding: 20px; padding-top: 30px;' {...getContentProps(description)} />}
          </>)}
        </ContentSmall>
      </ContentWrapper>
    </div>
  )
})`
  margin-top: 30px;

  color: rgb(100, 100, 100);
  font-size: 1.1em;
  line-height: 26px;
  padding-bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const ContentSmall = styled.div`
  display: none;
  @media only screen and (max-width: 500px) {
    display: block;
  }
`
const ContentWrapper = styled.div`
  display: flex;
  align-self: stretch;
  flex-direction: column;
`
const ContentBig = styled.div`
  display: flex;
  align-self: stretch;
  @media only screen and (max-width: 500px) {
    display: none;
  }
`
const Nav = styled.div`flex-grow: 1; display: flex; flex-direction: column;`
const Text = styled.div`
  max-width: 800px;
  flex-grow: 100000000000;
  margin-left: 25px;
  @media only screen and (max-width: 750px) {
    & {
      margin-left: 10px;
    }
  }
  & > *:first-child {
    margin-top: 0px;
  }
  & > h2 {
    color: ${inheritPrimaryColor};
    font-size: 1.5em;
    max-width: 75%;
   /* padding-left: 15px;
    border-left: 3px solid ${inheritPrimaryColor};*/
    font-weight: 300;
  }
  & > h2:not(:first-child) {
    margin-top: 50px;
  }
`
const Padding = styled.div`flex-basis: 0px; flex-grow: 1;min-width: 20px;`
const NavItem = styled(Link)`
  text-align: right;
  font-size: 1.4em;
  padding: 15px 20px;
  padding-right: 10px;
  @media only screen and (max-width: 750px) {
    & {
      font-size: 1em;
      padding-right: 8px;
    }
  }
  text-decoration: none;
  font-weight: bold;
  white-space: nowrap;
  ${p => p.active ? css`
    background-color: ${inheritPrimaryColor};
    color: white;
  ` : css`
    cursor: pointer;
    color: grey;
    &:hover {
      color: ${inheritPrimaryColor};
    }
  `}
`
const NavItemSmall = styled(Link)`
  padding: 15px 20px;
  text-decoration: none;
  font-weight: bold;
  display: block;
  white-space: nowrap;
  background-color: ${inheritPrimaryColor};
  border-bottom: 1px solid white;
  color: white;
  ${p => p.active ? '' : 'cursor: pointer;'}
`
const Header = styled.h1`
  color: ${inheritPrimaryColor};
  flex-grow: 1;
  max-width: 1140px;
`
const HeaderWrapper = styled.div`
  align-self: stretch;
  padding: 0px 20px 70px;
  display: flex;
  justify-content: center;
`

export default ResearchWrapper